var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('div',[_c('base-header')],1),_c('v-content',{staticClass:"content mt-2",class:`${_vm.$vuetify.breakpoint.xs ? '' : 'mb-5'}`},[_c('router-view')],1),_c('div',[_c('base-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }